import axios from 'axios';
import { apiPath ,getAuthConfig} from '../config/ApiConfig';

export async function getHMAC(endPoint, inputParam, successCallback, errorCallback) {
    try {
        const config = await getAuthConfig();

        const response = await axios.get(
            `${apiPath}${endPoint}${inputParam}`,
            config
        );

        const data = response.data;

        if (successCallback) successCallback(data);
        return data;

    } catch (error) {
        if (errorCallback) errorCallback(error);
    }
}
export async function postHMAC(endPoint, inputParam, successCallback, errorCallback) {
    try {
        const config = await getAuthConfig();
        const response = await axios.post(
            `${apiPath}${endPoint}`,
            { ...inputParam },
            config
        );

        const data = response.data;

        if (successCallback) return successCallback(data);
        return data;

    } catch (error) {
        if (errorCallback) errorCallback(error);
        throw error; // don't swallow errors
    }
}
     
export function getIpAddressEndpoint(endPoint,inputParam,sucessCallback, errorCallback) {
    return axios.get(`${endPoint}${inputParam}`,{timeout:20000}).then(response => response.data.ip)
        .then(sucessCallback)
        .catch(errorCallback);
}